<section [ngClass.gt-xs]="'row'"
         fxLayout="row" fxLayout.xs="column" fxLayoutAlign="space-between">

  <form *ngIf="employmentType.value" fxFlex="auto" [formGroup]="loan.form" fxLayout="column" fxLayoutGap="20px">
    <div fxLayout="row" fxLayoutGap="16px" fxLayout.xs="column">
      <bb-number number="2"></bb-number>
      <div class="slider" fxLayout="column" fxLayoutGap="16px">
        <div fxLayout="row" fxLayoutAlign="space-between" fxLayout.xs="column">
          <div class="request-txt">REQUESTED LOAN AMOUNT</div>
          <div class="subtle">Maximum loan is 2x salary</div>
        </div>
        <app-slider-input class="target_loan_amount"
                          [min]="targetLoanAmount.value.min"
                          [max]="targetLoanAmount.value.max"
                          [step]="targetLoanAmount.value.step"
                          formControlName="target_loan_amount">
          <div>₱ {{loan.form.get('target_loan_amount').value|number}}</div>
        </app-slider-input>
      </div>
    </div>

    <div fxLayout="row" fxLayoutGap="16px" fxLayout.xs="column">
      <bb-number number="3"></bb-number>
      <div class="slider" fxLayout="column" fxLayoutGap="16px">
        <div fxLayout="row" fxLayoutAlign="space-between" fxLayout.xs="column">
          <div class="request-txt">REQUESTED PAYMENT TERM</div>
          <div class="subtle">{{loanDuration}}</div>
        </div>
        <app-slider-input class="target_loan_duration"
                          [min]="targetLoanDuration.value.min"
                          [max]="targetLoanDuration.value.max"
                          [step]="targetLoanDuration.value.step"
                          formControlName="target_loan_duration">
          <div>{{loan.form.get('target_loan_duration').value}} Months</div>
        </app-slider-input>
      </div>
    </div>
  </form>

  <aside class="interest" fxFlex="none" fxLayout="column" fxLayoutAlign="center center">
    <div>
      <ng-container *ngIf="isGetLoan|async">
        EST. MONTHLY PAYMENT
      </ng-container>
    </div>

    <div class="rate">
      <ng-container *ngIf="isGetLoan|async">
        {{loan.form.get('estimated_monthly_payment').value|number}}
        <span class="symbol">PHP</span>
      </ng-container>
    </div>

    <div class="apply-now" (click)="forward()">APPLY NOW</div>
    <div *ngIf="isGetLoan|async" class="apr">the maximum APR on this loan is {{apr|async}}</div>
  </aside>

</section>
